export enum InscriptionTabs {
    GENERAL, VACANCIES, AUTHORIZATIONS, REQUIREMENTS, MERITS, EXAMS, DOCUMENTATION, PAYMENT
}
